import GermanyTractorLoading from '../../assets/gif/GermanyTractorLoading.gif';
import PortugalTractorLoading from '../../assets/gif/PortugalTractorLoading.gif';
import SpainTractorLoading from '../../assets/gif/SpainTractorLoading.gif';
import UKTractorLoading from '../../assets/gif/UKTractorLoading.gif';
import JDFLogo from '../../assets/svg/jdf_logo.svg';

import React from 'react';
import {useTranslation} from 'react-i18next';
import './TractorLoader.css';

const countryGifMap = {
  gb: UKTractorLoading,
  de: GermanyTractorLoading,
  pt: PortugalTractorLoading,
  es: SpainTractorLoading,
};

const TractorLoader = () => {
  const {t, i18n} = useTranslation();
  const countryCode = i18n.language?.toLowerCase();
  const loaderGif = countryGifMap[countryCode];

  return (
    <div className="tractor-loader-wrapper">
      <header id="tractorLoaderHeader" data-testid="tractorLoaderHeader">
        <div className="jdf-logo">
          <img src={JDFLogo} alt="JDF Logo" />
        </div>
      </header>
      <div className="tractor-loader-container">
        <img src={loaderGif} alt="Loading..." />
        <p className="tractor-loader-text">{t('LOADING_MESSAGE')}</p>
      </div>
    </div>
  );
};

export default TractorLoader;
